import z from "zod";
import { createEndpoint } from "../createEndpoint";
import { HttpClient } from "../httpClient";
import {
    GroupedServiceCategoryTreeSchema,
    PublicServiceCategorySchema,
    PublicServiceCategoryWithSubcategoriesSchema,
} from "../schemas/service-categories";

export function createCategoriesApi(http: HttpClient, baseUrl: string) {
    const categoriesBaseUrl = `${baseUrl}/service-categories`;
    return {
        getCategories: createEndpoint(http, 'GET', '/', {
            base: categoriesBaseUrl,
            responseSchema: z.array(PublicServiceCategorySchema),
        }),
        getCategoriesWithSubcategories: createEndpoint(http, 'GET', '-with-subs', {
            base: categoriesBaseUrl,
            responseSchema: z.array(PublicServiceCategoryWithSubcategoriesSchema),
        }),
        getGroupedCategoriesWithSubcategories: createEndpoint(http, 'GET', '-grouped-with-subs', {
            base: categoriesBaseUrl,
            responseSchema: GroupedServiceCategoryTreeSchema,
        }),
        getSubCategories: createEndpoint(http, 'GET', '/:slug', {
            base: categoriesBaseUrl,
            responseSchema: z.array(PublicServiceCategorySchema),
            params: ['slug'],
        }),
    }
}
